import axios from 'axios';

declare global {
  interface Window {
    axios: typeof axios;
  }
}

window.axios = axios;
window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
window.axios.defaults.withCredentials = true;

const token = document.querySelector<HTMLMetaElement>('meta[name="csrf-token"]')?.content || '';

if (token) {
  window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token;
}
